import { Subject } from 'rxjs'
import { Flatfile } from '@flatfile/api-internal'

export const EventStream = new Subject<Flatfile.Event>()

export type BaseEvent = {
  topic: string
  target?: string
  context: Record<string, any>
}
